/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum PlayerKind {
  BOT = 'BOT',
  HUMAN = 'HUMAN'
}

/**
 * PlayerKind
 *
 * The different kinds of players
 */
export const PlayerKindEnumType = types.enumeration('PlayerKind', ['BOT', 'HUMAN'])
